module.exports = __webpack_public_path__ + "media/video1.495f05b1.mp4";